/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // =====================================================
  // TIERED GIFT CARD BONUS SYSTEM
  // Buy gift cards, get bonus gift cards automatically
  // =====================================================
  const bonusGiftCards = {
    500: { variant_id: 41957033312279, title: "$100 Gift Card" },
    400: { variant_id: 41957032656919, title: "$80 Gift Card" },
    300: { variant_id: 41957031706647, title: "$60 Gift Card" },
    200: { variant_id: 41957031444503, title: "$40 Gift Card" },
    100: { variant_id: 41957025513495, title: "$20 Gift Card" }
  };

  async function fetchCart() {
    try {
      let response = await fetch('/cart.js');
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error("Error fetching cart:", error);
      return null;
    }
  }

  async function addBonusToCart(variantId, quantity) {
    if (!Number.isInteger(variantId)) {
      console.error(`Invalid Variant ID: ${variantId}`);
      return;
    }

    try {
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });

      let updatedCart = await response.json();
      if (!response.ok) {
        console.error(`Shopify API Error: ${updatedCart.message}`);
        throw new Error(updatedCart.message);
      }

      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      return updatedCart;
    } catch (error) {
      console.error(`Error adding bonus to cart:`, error);
    }
  }

  async function removeBonusFromCart(variantId) {
    if (!Number.isInteger(variantId)) {
      console.error(`Invalid Variant ID: ${variantId}`);
      return;
    }

    try {
      let response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: 0 })
      });

      let updatedCart = await response.json();
      if (!response.ok) {
        console.error(`Shopify API Error: ${updatedCart.message}`);
        throw new Error(updatedCart.message);
      }

      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      return updatedCart;
    } catch (error) {
      console.error(`Error removing bonus from cart:`, error);
    }
  }

  async function checkAndApplyBonuses() {
    let cart = await fetchCart();
    if (!cart) return;

    // Calculate total of gift card products only
    let gc_cartTotal = 0;
    cart.items.forEach(item => {
      if (item.product_type === "Gift Cards") {
        gc_cartTotal += item.final_line_price;
      }
    });
    gc_cartTotal = gc_cartTotal / 100; // Convert cents to dollars

    // Determine which bonus tier is earned
    let earnedBonusId;
    if (gc_cartTotal >= 500) {
      earnedBonusId = bonusGiftCards[500].variant_id;
    } else if (gc_cartTotal >= 400) {
      earnedBonusId = bonusGiftCards[400].variant_id;
    } else if (gc_cartTotal >= 300) {
      earnedBonusId = bonusGiftCards[300].variant_id;
    } else if (gc_cartTotal >= 200) {
      earnedBonusId = bonusGiftCards[200].variant_id;
    } else if (gc_cartTotal >= 100) {
      earnedBonusId = bonusGiftCards[100].variant_id;
    }

    let cartItemVariants = cart.items.map(item => item.id);
    let hasEarnedBonusCard = earnedBonusId && cartItemVariants.includes(earnedBonusId);

    // Find any bonus cards in cart that shouldn't be there
    let appliedBonuses = cartItemVariants.filter(variantId =>
      Object.values(bonusGiftCards).some(gift => gift.variant_id === variantId)
    );

    let wrongBonuses = appliedBonuses.filter(bonus => bonus !== earnedBonusId);

    // Remove incorrect bonus cards
    if (wrongBonuses.length > 0) {
      for (const bonus of wrongBonuses) {
        await removeBonusFromCart(bonus);
      }
    }

    // Add correct bonus card if earned and not in cart
    if (earnedBonusId && !hasEarnedBonusCard) {
      await addBonusToCart(earnedBonusId, 1);
    }
  }

  // Watch for variant option changes and handle quotify visibility
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for changes on variant option inputs
    var variantInputs = document.querySelectorAll('input[name^="options"]');
    variantInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Get product data
        var productFormScript = document.querySelector('[data-product-json]');
        if (productFormScript) {
          var product = JSON.parse(productFormScript.textContent);

          // Get currently selected options
          var selectedOptions = [];
          document.querySelectorAll('input[name^="options"]:checked').forEach(function(opt) {
            selectedOptions.push(opt.value);
          });

          // Find matching variant
          var currentVariant = product.variants.find(function(v) {
            return v.options.every(function(option, index) {
              return option === selectedOptions[index];
            });
          });

          // Hide/show quotify button based on availability
          if (currentVariant) {
            var quotifyBlocks = document.querySelectorAll('[class*="quotify"]');
            quotifyBlocks.forEach(function(block) {
              if (currentVariant.available) {
                block.style.display = '';
              } else {
                block.style.display = 'none';
              }
            });
          }
        }
      });
    });
  });

 document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('[Custom] Variant changed:', variant.title);

      // Update variant option displays
      updateVariantOptionDisplays(variant, container);

      // Update product image to variant featured image
      updateProductImage(variant, container);

      // Hide/show Quotify button based on availability
      var quotifyBlocks = document.querySelectorAll('[class*="quotify"]');
      quotifyBlocks.forEach(function(block) {
        if (variant.available) {
          block.style.display = '';
        } else {
          block.style.display = 'none';
        }
      });
    }
  });

  // Function to update variant option displays
  function updateVariantOptionDisplays(variant, container) {
    // Update all data-option-value elements (these show the selected option value)
    var optionValueElements = container.querySelectorAll('[data-option-value]');

    if (variant.options && optionValueElements.length > 0) {
      // Update each option value display
      variant.options.forEach(function(optionValue, index) {
        if (optionValueElements[index]) {
          optionValueElements[index].textContent = optionValue;
        }
      });
    }

    // Also update data-swapper-target elements (alternative display method)
    var swapperTargets = container.querySelectorAll('[data-swapper-target]');
    swapperTargets.forEach(function(element) {
      // Find the closest parent that has data-option-position to know which option this is for
      var wrapper = element.closest('[data-option-position]');
      if (wrapper) {
        var optionPosition = parseInt(wrapper.getAttribute('data-option-position')) - 1;
        if (variant.options && variant.options[optionPosition] !== undefined) {
          element.textContent = variant.options[optionPosition];
        }
      }
    });
  }

  // Function to update product image
  function updateProductImage(variant, container) {
    // Only update if variant has a featured image
    if (!variant.featured_media || !variant.featured_media.preview_image) {
      return;
    }

    var variantImageSrc = variant.featured_media.preview_image.src;
    var variantImageId = variant.featured_media.id;

    console.log('[Custom] Updating to variant image:', variantImageSrc);

    // Find the product slideshow/grid container
    var productSlideshow = container.querySelector('[data-product-slideshow]');
    if (!productSlideshow) {
      return;
    }

    // Check if we're in slideshow mode or grid mode
    var isSlideshow = productSlideshow.classList.contains('flickity-enabled');

    if (isSlideshow) {
      // Handle slideshow mode - find the slide with matching media ID
      var targetSlide = productSlideshow.querySelector('[data-media-id="' + variantImageId + '"]');
      if (targetSlide) {
        var slideIndex = Array.from(targetSlide.parentElement.children).indexOf(targetSlide);

        // Use Flickity API to select the slide
        if (window.Flickity) {
          var flkty = Flickity.data(productSlideshow);
          if (flkty) {
            flkty.select(slideIndex);
          }
        }
      }
    } else {
      // Handle grid/stacked mode - scroll to the image
      var targetMedia = productSlideshow.querySelector('[data-media-id="' + variantImageId + '"]');
      if (targetMedia) {
        // Smooth scroll to the image
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        // Also update thumbnails if present
        updateThumbnailSelection(variantImageId, container);
      }
    }
  }

  // Function to update thumbnail selection
  function updateThumbnailSelection(mediaId, container) {
    // Remove active class from all thumbnails
    var thumbnails = container.querySelectorAll('[data-slideshow-thumbnail]');
    thumbnails.forEach(function(thumb) {
      thumb.classList.remove('is-activated');
    });

    // Add active class to matching thumbnail
    var activeThumbnail = container.querySelector('[data-media-select="' + mediaId + '"]');
    if (activeThumbnail) {
      activeThumbnail.classList.add('is-activated');
    }
  }


  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // Check and apply gift card bonuses
      setTimeout(checkAndApplyBonuses, 100);
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
    // Check and apply gift card bonuses on init
    checkAndApplyBonuses();
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Run initial gift card bonus check on page load
  document.addEventListener("DOMContentLoaded", function() {
    checkAndApplyBonuses();
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
